import {FC} from 'react';

export const StandartDeliverySelectorOptionIcon: FC<{height?: string; width?: string}> = ({
  height = '33px',
  width = '32px'
}) => (
  <svg width={width} height={height} viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10302_159953)">
      <path d="M13.1204 20.7915H11.9033V27.1128H13.1204V20.7915Z" fill="#077769" />
      <path
        d="M13.0448 27.1052C14.6244 27.1052 15.9049 25.6918 15.9049 23.9484C15.9049 22.2049 14.6244 20.7915 13.0448 20.7915C11.4651 20.7915 10.1846 22.2049 10.1846 23.9484C10.1846 25.6918 11.4651 27.1052 13.0448 27.1052Z"
        fill="#085F54"
      />
      <path
        d="M12.0096 27.105C13.5892 27.105 14.8698 25.6916 14.8698 23.9481C14.8698 22.2046 13.5892 20.7913 12.0096 20.7913C10.43 20.7913 9.14941 22.2046 9.14941 23.9481C9.14941 25.6916 10.43 27.105 12.0096 27.105Z"
        fill="#077769"
      />
      <path
        d="M11.9035 24.937C12.3992 24.937 12.8011 24.4943 12.8011 23.9481C12.8011 23.402 12.3992 22.9592 11.9035 22.9592C11.4077 22.9592 11.0059 23.402 11.0059 23.9481C11.0059 24.4943 11.4077 24.937 11.9035 24.937Z"
        fill="white"
      />
      <path d="M25.9808 20.7915H24.7637V27.1128H25.9808V20.7915Z" fill="#077769" />
      <path
        d="M25.9041 27.1052C27.4838 27.1052 28.7643 25.6918 28.7643 23.9484C28.7643 22.2049 27.4838 20.7915 25.9041 20.7915C24.3245 20.7915 23.0439 22.2049 23.0439 23.9484C23.0439 25.6918 24.3245 27.1052 25.9041 27.1052Z"
        fill="#085F54"
      />
      <path
        d="M24.869 27.105C26.4486 27.105 27.7292 25.6916 27.7292 23.9481C27.7292 22.2046 26.4486 20.7913 24.869 20.7913C23.2893 20.7913 22.0088 22.2046 22.0088 23.9481C22.0088 25.6916 23.2893 27.105 24.869 27.105Z"
        fill="#077769"
      />
      <path
        d="M24.7638 24.937C25.2596 24.937 25.6614 24.4943 25.6614 23.9481C25.6614 23.402 25.2596 22.9592 24.7638 22.9592C24.2681 22.9592 23.8662 23.402 23.8662 23.9481C23.8662 24.4943 24.2681 24.937 24.7638 24.937Z"
        fill="white"
      />
      <path
        d="M0 9.13178V22.1852C0 23.1665 0.791108 23.9576 1.77239 23.9576H17.2441C18.2253 23.9576 19.0165 23.1665 19.0165 22.1852V12.6766C19.0165 11.6953 19.8076 10.9042 20.7888 10.9042H22.1581C23.1393 10.9042 23.9305 10.1131 23.9305 9.13178C23.9305 8.15049 23.1393 7.35938 22.1581 7.35938L1.77239 7.35938C0.791108 7.35938 0 8.15049 0 9.13178Z"
        fill="#077769"
      />
      <path
        d="M0 7.98725V20.5854C0 21.5667 0.791108 22.3578 1.77239 22.3578H17.3725C18.3537 22.3578 19.1448 21.5667 19.1448 20.5854V12.675C19.1448 11.6937 19.936 10.9026 20.9172 10.9026H22.2865C23.2677 10.9026 23.7746 10.7863 23.7741 7.98725C23.7741 7.00596 22.983 6.21484 22.0017 6.21484H1.77239C0.791108 6.21484 0 7.00596 0 7.98725Z"
        fill="#229C8B"
      />
      <path
        d="M18.6748 12.9136C18.6748 11.6863 19.6697 10.6914 20.897 10.6914H28.2523C28.818 10.6914 29.3623 10.9071 29.7744 11.2945L31.745 13.147C32.1917 13.567 32.4451 14.1529 32.4451 14.7661V21.3508C32.4451 22.158 32.0194 22.9053 31.3251 23.317L30.1313 24.0247H18.6748"
        fill="#FF787C"
      />
      <path
        d="M23.6757 10.6914L27.0091 13.4692V24.0247H18.2861V12.4246C18.2861 11.5157 19.0144 10.7744 19.9231 10.7582L23.6757 10.6914Z"
        fill="#FA4147"
      />
      <path d="M6.03155 20.7915H4.81445V27.1128H6.03155V20.7915Z" fill="#077769" />
      <path
        d="M5.95394 27.1052C7.53357 27.1052 8.81412 25.6918 8.81412 23.9484C8.81412 22.2049 7.53357 20.7915 5.95394 20.7915C4.3743 20.7915 3.09375 22.2049 3.09375 23.9484C3.09375 25.6918 4.3743 27.1052 5.95394 27.1052Z"
        fill="#085F54"
      />
      <path
        d="M4.91976 27.105C6.49939 27.105 7.77994 25.6916 7.77994 23.9481C7.77994 22.2046 6.49939 20.7913 4.91976 20.7913C3.34012 20.7913 2.05957 22.2046 2.05957 23.9481C2.05957 25.6916 3.34012 27.105 4.91976 27.105Z"
        fill="#077769"
      />
      <path
        d="M4.81326 25.1711C5.42691 25.1711 5.92437 24.6231 5.92437 23.947C5.92437 23.271 5.42691 22.7229 4.81326 22.7229C4.19961 22.7229 3.70215 23.271 3.70215 23.947C3.70215 24.6231 4.19961 25.1711 4.81326 25.1711Z"
        fill="white"
      />
      <path
        d="M31.8509 13.4688H26.8799V24.0243H30.0026C31.2649 24.0243 32.2884 23.0016 32.2884 21.7393V15.1354C32.2884 14.691 32.4064 14.0243 31.8509 13.4688Z"
        fill="#E82026"
      />
      <path
        d="M19.1021 6.21484C17.8748 6.21484 16.8799 7.20977 16.8799 8.43707V22.3584L18.5465 21.8029V12.914C18.5465 11.6867 19.5415 10.6918 20.7688 10.6918H23.2877C23.7348 10.6918 24.1021 10.3402 24.1021 9.91229V6.9943C24.1021 6.56636 23.7348 6.21484 23.2877 6.21484H19.1021Z"
        fill="#077769"
      />
      <path d="M20.2952 20.9121H19.0781V27.2334H20.2952V20.9121Z" fill="#077769" />
      <path
        d="M20.2117 27.2258C21.7914 27.2258 23.0719 25.8124 23.0719 24.069C23.0719 22.3255 21.7914 20.9121 20.2117 20.9121C18.6321 20.9121 17.3516 22.3255 17.3516 24.069C17.3516 25.8124 18.6321 27.2258 20.2117 27.2258Z"
        fill="#085F54"
      />
      <path
        d="M19.1834 27.2258C20.7631 27.2258 22.0436 25.8124 22.0436 24.069C22.0436 22.3255 20.7631 20.9121 19.1834 20.9121C17.6038 20.9121 16.3232 22.3255 16.3232 24.069C16.3232 25.8124 17.6038 27.2258 19.1834 27.2258Z"
        fill="#077769"
      />
      <path
        d="M19.0769 25.2959C19.6906 25.2959 20.188 24.7478 20.188 24.0718C20.188 23.3957 19.6906 22.8477 19.0769 22.8477C18.4633 22.8477 17.9658 23.3957 17.9658 24.0718C17.9658 24.7478 18.4633 25.2959 19.0769 25.2959Z"
        fill="white"
      />
      <path
        d="M25.0077 14.9219C24.1966 14.9219 23.6589 15.7626 23.999 16.4989L25.1232 18.9327C25.3049 19.3261 25.6986 19.5779 26.1319 19.5779H32.2884L32.3208 14.9219H25.0077Z"
        fill="white"
      />
      <path d="M26.8799 19.579V14.9219H32.3241V19.579H26.8799Z" fill="#F4F4F4" />
    </g>
    <defs>
      <clipPath id="clip0_10302_159953">
        <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
